// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import clockRefreshIcon from "@/assets/icons/clock-refresh.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ClockRefreshIconProps = Omit<IconProps, "name">;

export function ClockRefreshIcon(props: ClockRefreshIconProps): React.ReactNode {
  return <Icon name={clockRefreshIcon} {...props} />;
}
